import { render, staticRenderFns } from "./MentalDrawingPreview.vue?vue&type=template&id=8bf87766&lang=pug&"
import script from "./MentalDrawingPreview.vue?vue&type=script&lang=js&"
export * from "./MentalDrawingPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports